import React, { useCallback, useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useStore } from "../../../../../../hooks";
import {
  TableWrapper,
  headCellStyle,
  bodyCellStyle,
  toolbarStyle,
  tableContainerStyle,
  tablePaperStyle
} from "../../../../../../elements/v2/Tables/Table.styled";
import { useMediaQueries } from "../../../../../../utils/mediaQueries";
import TooltipTable from "../../../../../../elements/v2/TooltipTable/TooltipTable";
import { ContainerLog, HeadCellLog } from "../Marketing.styled";
import Spinner from "../../../../../../components/common/Spinner";
import { SuccessfulModal } from "../../../../../../elements";
import { auditLogColumns } from "./AuditLogColumns";

const AuditLogs = observer(() => {
  const { marketingStore } = useStore();
  const { auditLogsStore } = marketingStore;
  
  if (!auditLogsStore) {
    return <Spinner />;
  }
  
  const { isMobile, isTablet, isDesktop } = useMediaQueries();

  const table = useMaterialReactTable({
    columns: auditLogColumns,
    data: auditLogsStore.auditLogs,
    manualSorting: true,
    manualGlobalFilter: true,
    rowCount: auditLogsStore.totalRowCount || 0,
    initialState: { sorting: auditLogsStore.sorting },
    muiTableContainerProps: { sx: tableContainerStyle },
    muiTablePaperProps: { elevation: 0, sx: tablePaperStyle },
    muiTableHeadCellProps: { sx: HeadCellLog },
    muiTableBodyCellProps: { sx: bodyCellStyle },

    muiTopToolbarProps: { sx: toolbarStyle },
    muiSearchTextFieldProps: {
      variant: 'outlined',
      placeholder: 'Search',
      InputProps: { style: { fontSize: '12px' } },
    },
    showGlobalFilter: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableGrouping: false,
    enableTopToolbar: true,
  });

  return (
    <ContainerLog>
      {auditLogsStore.isLoading && <Spinner />}
      {!auditLogsStore.isLoading && (
        <TableWrapper>
          <MaterialReactTable table={table} />
        </TableWrapper>
      )}
    </ContainerLog>
  );
});

export default AuditLogs;
